import { Injectable, signal } from '@angular/core';

interface TaskDescriptionDraft {
  readonly taskId: string;
  readonly value: string;
}

/**
 * PROPOZYCJA — DO WERYFIKACJI: splitview-scoped UI draft state. The existing
 * ActiveTaskService keeps the navigation guard, but the editor is destroyed when
 * mobile and desktop details swap. This retains only unsaved text across that swap.
 */
@Injectable()
export class TaskDescriptionDraftService {
  private readonly draft = signal<TaskDescriptionDraft | null>(null);

  public get(taskId: string): string | null {
    const draft = this.draft();
    return draft?.taskId === taskId ? draft.value : null;
  }

  public set(taskId: string, value: string): void {
    this.draft.set({ taskId, value });
  }

  public clear(taskId: string): void {
    if (this.draft()?.taskId === taskId) {
      this.draft.set(null);
    }
  }

  public clearAll(): void {
    this.draft.set(null);
  }
}
